import { App, reactive } from 'vue';
import {
  colorManager,
  colors,
} from '@constants/colors';

const ColorPlugin = {
  install(app: App) {
    app.provide('$colorManager', reactive(colorManager));
    app.provide('$colors', colors);
  },
};

export default ColorPlugin;
